import * as types from './constants';

// Get New Arrivals
export const getNewArrivalsRequest = data => (
  { type: types.GET_NEW_ARRIVALS_REQUEST, payload: data }
);

export const getNewArrivalsDone = data => (
  { type: types.GET_NEW_ARRIVALS_DONE, payload: data }
);

export const getNewArrivalsFailed = errors => (
  { type: types.GET_NEW_ARRIVALS_FAILED, payload: errors }
);

export const getNewArrivalsReset = () => (
  { type: types.GET_NEW_ARRIVALS_RESET }
);